import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { useLoggedUser } from "../../../../utils/useLoggedUser";
import { fetchWorkEntriesProjectTracking } from "../../../../store/slices/workentriesSlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import ProgressTracker from "../../../../utils/ProgressTracker";
import TaskTrackOP from "./TaskTrackOP";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import { fetchHardwareProjectTracking } from "../../../../store/slices/hardwareDescriptionSlice";
import OPHardwareOngoing from "./OPHardwareOngoing";
import { fetchDescriptionTasksProjectTracking } from "../../../../store/slices/DescriptionTask";
import FileUploadOP from "../FileUploadOP";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { setPersonReadTrue } from "../../../../store/slices/readSlice";
import DateConversion from "../../../../utils/DateConversion";
import { setSelectedProjectName } from "../../../../store/slices/ProjectOngoing/taskScrollSlice";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";

const ProjectOngoingOPDash = ({ ongoingOpProjects, handlerefresh, isViewOnly = false }) => {
  const loggedUser = useLoggedUser();
  const { formatDateByCountry } = DateConversion();

  const dispatch = useDispatch();
  const { employees } = useSelector((state) => state.employees);
  // const { projects } = useSelector((state) => state.projects);

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const { leads } = useSelector((state) => state.leads);
  const { group: groups } = useSelector((state) => state.group);

  const selectedProjectName = useSelector(
    (state) => state.taskScroll.selectedProjectName
  );
  console.log("selectedTaskId selectedProjectName", selectedProjectName);

  const LoggedUser = localStorage.getItem("email");

  const groupNameById = useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name =
        g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      if (typeof projectRow?.group === "string" && projectRow.group.trim()) {
        return projectRow.group;
      }

      const directGroupName =
        projectRow?.group?.newGroupName ||
        projectRow?.group?.groupname ||
        projectRow?.group?.groupName ||
        projectRow?.group?.name ||
        projectRow?.groupid?.newGroupName ||
        projectRow?.groupid?.groupname ||
        projectRow?.groupid?.groupName ||
        projectRow?.groupid?.name ||
        projectRow?.groupId?.newGroupName ||
        projectRow?.groupId?.groupname ||
        projectRow?.groupId?.groupName ||
        projectRow?.groupId?.name ||
        projectRow?.lead?.groupid?.newGroupName ||
        projectRow?.lead?.groupid?.groupname ||
        projectRow?.lead?.groupid?.groupName ||
        projectRow?.lead?.groupid?.name ||
        projectRow?.lead?.groupId?.newGroupName ||
        projectRow?.lead?.groupId?.groupname ||
        projectRow?.lead?.groupId?.groupName ||
        projectRow?.lead?.groupId?.name;

      if (directGroupName) return directGroupName;

      const groupId =
        projectRow?.group?._id ||
        projectRow?.group?.id ||
        projectRow?.group ||
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId;

      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }

      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchEmployees());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  }, [dispatch]);

  const refresh = () => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchEmployees());
    dispatch(fetchLeads());
    dispatch(fetchGroups());
    dispatch(getMyTrainings());
  };

  const [loggedUserEmp, setLoggedUser] = useState(null);
  useEffect(() => {
    const loggedEmail = localStorage.getItem("email");
    const LoggedEmp = employees.find((emp) => emp.EmpEmail === loggedEmail);
    setLoggedUser(LoggedEmp);
  }, [employees]);

  const [customProjectData, setCustomProjectData] = useState([]);

  useEffect(() => {
    if (!ongoingOpProjects?.length || !projectTrackingWorkEntries?.length) {
      setCustomProjectData([]);
      return;
    }

    const mergedData = ongoingOpProjects.map((project) => {
      const isHardware =
        project?.TypeService?.toLowerCase().includes("hardware");

      const totalWorkEntries = isHardware
        ? hardwareProjectTracking.filter(
            (entry) =>
              entry.projectid === project._id &&
              loggedUserEmp?._id === entry.taskownerid
          )
        : projectTrackingWorkEntries.filter(
            (entry) =>
              entry.projectid === project._id &&
              loggedUserEmp?._id === entry.taskownerid
          );

      const totalDescriptionEntries = descriptionProjectTracking.filter(
        (entry) =>
          entry.projectid === project._id &&
          loggedUserEmp?._id === entry.taskownerid
      );

      let calculatedAggregateMap = 0;

      if (isHardware) {
        // ✅ existing logic (unchanged)
        // const allEntries = [...totalWorkEntries, ...totalDescriptionEntries];

        // const totalTasks = allEntries.length;
        // const completedTasks = allEntries.filter(
        //   (entry) => entry.isTaskComplete
        // ).length;

        // calculatedAggregateMap =
        //   totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;
            const completedWorkEntries = totalWorkEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const completedDescriptions = totalDescriptionEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const workProgress =
          totalWorkEntries.length > 0
            ? (completedWorkEntries / totalWorkEntries.length) * 90
            : 0;

        const descriptionProgress =
          totalDescriptionEntries.length > 0
            ? (completedDescriptions / totalDescriptionEntries.length) * 10
            : 0;

        calculatedAggregateMap = workProgress + descriptionProgress;
      } else {
        // ✅ proportion-based logic (90% + 10%)

        const completedWorkEntries = totalWorkEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const completedDescriptionEntries = totalDescriptionEntries.filter(
          (entry) => entry.isTaskComplete
        ).length;

        const workProgress =
          totalWorkEntries.length > 0
            ? (completedWorkEntries / totalWorkEntries.length) * 90
            : 0;

        const descriptionProgress =
          totalDescriptionEntries.length > 0
            ? (completedDescriptionEntries / totalDescriptionEntries.length) *
              10
            : 0;

        calculatedAggregateMap = workProgress + descriptionProgress;
      }

      return {
        projectid: project._id,
        totalWorkEntries,
        calculatedAggregateMap,
      };
    });

    setCustomProjectData(mergedData);
  }, [
    ongoingOpProjects,
    projectTrackingWorkEntries,
    loggedUserEmp,
    descriptionProjectTracking,
    hardwareProjectTracking,
  ]);

  // useEffect(() => {
  //   if (!ongoingOpProjects?.length || !projectTrackingWorkEntries?.length) {
  //     setCustomProjectData([]);
  //     return;
  //   }

  //   const mergedData = ongoingOpProjects.map((project) => {
  //     // get all tasks/work entries for this project
  //     const totalWorkEntries = project?.TypeService?.toLowerCase().includes("hardware") ?
  //       // const totalWorkEntries = project.TypeService === "Hardware" ?
  //       hardwareProjectTracking.filter(
  //         (entry) =>
  //           entry.projectid === project._id &&
  //           loggedUserEmp?._id === entry.taskownerid
  //       )
  //       : projectTrackingWorkEntries.filter(
  //         (entry) =>
  //           entry.projectid === project._id &&
  //           loggedUserEmp?._id === entry.taskownerid
  //       );
  //     const totalDescriptionEntries = descriptionProjectTracking.filter(
  //       (entry) =>
  //         entry.projectid === project._id &&
  //         loggedUserEmp?._id === entry.taskownerid
  //     );

  //     const allEntries = [...totalWorkEntries, ...totalDescriptionEntries]

  //     // calculate completion %
  //     const totalTasks = allEntries.length;
  //     const completedTasks = allEntries.filter(
  //       (entry) => entry.isTaskComplete
  //     ).length;

  //     const calculatedAggregateMap =
  //       totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  //     return {
  //       projectid: project._id,
  //       totalWorkEntries,
  //       calculatedAggregateMap,
  //     };
  //   });

  //   setCustomProjectData(mergedData);
  // }, [ongoingOpProjects, projectTrackingWorkEntries, loggedUserEmp, descriptionProjectTracking, hardwareProjectTracking]);

  const [isLoading, setIsLoading] = useState(false);

  const [openInputReceived, setOpenInputReceived] = useState(null);

  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const [sortedProjects, setSortedProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    setSortedProjects(ongoingOpProjects);
    setCurrentPage(1);
  }, [ongoingOpProjects]);

  const itemsPerPage = 10; // or any number of rows you want per page

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects?.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = ongoingOpProjects.filter((LeadReport) =>
      (getDisplayGroupName(LeadReport) || "")
        .toString()
        .trim()
        .toLowerCase()
        .includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(a), getDisplayGroupName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(b), getDisplayGroupName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [openIndex, setOpenIndex] = useState(null); // store index instead of boolean
  const [aggregateProgressMap, setAggregateProgressMap] = useState({});
  const [showListState, setShowListState] = useState("tasktable");
  const [rowID, setRowID] = useState(null);
  const [clickedProject, setClickedProject] = useState(null);

  const handleleadread = async (row) => {
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const isUserAssigned = row.Assignedperson?.find(
      (person) => person.email === email // replace with your actual logged user email variable
    );
    const projectId = row._id;
    const personId = currentEmployee._id;

    if (isUserAssigned.isRead === false) {
      try {
        await dispatch(setPersonReadTrue({ projectId, personId }));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        handlerefresh();
      }
    }
  };

  const ProjectOngoingOpref = useRef(null);
  useEffect(() => {
    if (rowID) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectOngoingOpref.current.scrollWidth;
      ProjectOngoingOpref.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [rowID]);

  useEffect(() => {
    if (!selectedProjectName || !sortedProjects) return;

    // Find index in the FULL list (not the paginated one)
    const globalIndex = sortedProjects.findIndex(
      (p) => p.ProjectName?.toLowerCase() === selectedProjectName?.toLowerCase()
    );

    if (globalIndex === -1) return;

    // Calculate page number where that project exists
    const pageNumber = Math.floor(globalIndex / itemsPerPage) + 1;

    // Change the page first
    if (pageNumber !== currentPage) {
      setCurrentPage(pageNumber);
    }
  }, [selectedProjectName, currentPage, sortedProjects]);

  const refs = useRef({}); // store refs by task id

  useEffect(() => {
    if (
      selectedProjectName &&
      paginatedProjects.length > 0 &&
      refs.current[selectedProjectName]
    ) {
      // Delay scroll until after the DOM expands
      setTimeout(() => {
        if (refs.current[selectedProjectName]) {
          refs.current[selectedProjectName].scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }

        dispatch(setSelectedProjectName(null));
      }, 50); // 0–50ms works best
    }
  }, [selectedProjectName, paginatedProjects, dispatch]);

  // useEffect(() => {
  //   if (
  //     selectedProjectName &&
  //     paginatedProjects.length > 0 &&
  //     refs.current[selectedProjectName]
  //   ) {
  //     refs.current[selectedProjectName].scrollIntoView({
  //       behavior: "smooth",
  //       block: "center",
  //     });

  //     dispatch(setSelectedProjectName(null));
  //   }
  // }, [selectedProjectName, paginatedProjects, dispatch]);

  useEffect(() => {
    if (selectedProjectName) {
      const ProjectToScroll = paginatedProjects?.find(
        (proj) => proj?.ProjectName === selectedProjectName
      );
      setRowID(ProjectToScroll?._id);
      setShowListState("tasktable");
    }
    if (selectedProjectName) {
      const index = paginatedProjects.findIndex(
        (p) =>
          p.ProjectName?.toLowerCase() === selectedProjectName?.toLowerCase()
      );
      if (index !== -1) {
        setOpenIndex(index);
      } else {
        setOpenIndex(null); // not found
      }
    }
  }, [selectedProjectName, paginatedProjects]);

  return (
    <div>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <></>}
      <>
        <div className="flex justify-between rounded-t-md items-center p-2 bg-white">
          <div className="font-semibold ">Project Ongoing</div>
          <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
            <MdSearch className=" w-5 h-5 text-gray-500" />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="Search"
              className="bg-[#e0e7ff] outline-none w-[80%]"
            />
          </div>
        </div>
        <div
          ref={ProjectOngoingOpref}
          className="w-full min-h-[32vh] overflow-x-auto bg-white   h-full max-h-[95vh] overflow-auto "
        >
          <div className={`${rowID ? "" : "w-full"} `}>
            <div className="head bg-white rounded-t sticky top-0 z-[999]">
              <div className="flex w-[100%] bg-[#E8E8E8] text-black text-xs  text-center">
                <div className="flex w-[100%] break-all whitespace-normal">
                  <div
                    className={`${rowID ? "" : "w-[70%]"}  flex font-semibold`}
                  >
                    <div className="w-14 border flex justify-start bg-[#E8E8E8] pl-3 items-center ">
                      Sr. No
                    </div>
                    <div
                      className={`${
                        rowID ? "w-32" : "w-[20%]"
                      } bg-[#E8E8E8] border p-1 break-words text-wrap flex justify-around items-center align-middle`}
                    >
                      <p className="w-[75%] text-start break-words whitespace-normal">
                        Group
                      </p>
                      <div className="w-[25%] flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("AssignedGroup", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`${
                        rowID ? "w-32" : "w-[20%]"
                      } bg-[#E8E8E8] border p-2 break-words text-wrap flex justify-start items-center align-middle`}
                    >
                      <p className="w-[75%] text-start break-words whitespace-normal">
                        Project
                      </p>
                      <div className="w-[25%] flex flex-col">
                        <div
                          className="cursor-pointer "
                          onClick={() =>
                            sortAlphabetically("ProjectName", "az")
                          }
                        >
                          <ArrowDropUp
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>

                        <div
                          className="cursor-pointer -mt-2"
                          onClick={() =>
                            sortAlphabetically("ProjectName", "za")
                          }
                        >
                          <ArrowDropDown
                            color="white"
                            sx={{ fontSize: "22px" }}
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className={`${
                        rowID ? "w-32" : "w-[20%]"
                      } bg-[#E8E8E8] relative border p-2 flex justify-center items-center`}
                    >
                      <p className="">
                        Date Requested
                      </p>
                      <div className="absolute right-1 flex flex-col -mt-1">
                        <ArrowDropUp
                          className="cursor-pointer"
                          sx={{ fontSize: "20px" }}
                          onClick={() =>
                            sortAlphabetically("DateRequested", "az")
                          }
                        />
                        <ArrowDropDown
                          className="cursor-pointer -mt-2"
                          sx={{ fontSize: "20px" }}
                          onClick={() =>
                            sortAlphabetically("DateRequested", "za")
                          }
                        />
                      </div>
                    </div>

                    <div
                      className={`${
                        rowID ? "w-32" : "w-[20%]"
                      } bg-[#E8E8E8] relative border p-2 flex justify-center items-center`}
                    >
                      <p className=" text-start break-words whitespace-normal">
                        Due Date
                      </p>
                      <div className="absolute right-1 flex flex-col -mt-1">
                        <ArrowDropUp
                          className="cursor-pointer"
                          sx={{ fontSize: "20px" }}
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "az")
                          }
                        />
                        <ArrowDropDown
                          className="cursor-pointer -mt-2"
                          sx={{ fontSize: "20px" }}
                          onClick={() =>
                            sortAlphabetically("ProjectDueDate", "za")
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={`${
                        rowID ? "w-32" : "w-[20%]"
                      } bg-[#E8E8E8] border p-2 flex justify-center items-center`}
                    >
                      Attachment
                    </div>
                  </div>

                  {rowID ? (
                    <>
                      <div className=" font-semibold h-full bg-[#E8E8E8] border break-words text-wrap flex justify-around items-center align-middle">
                        <div className="h-full w-[50rem]">
                          <div className="w-full h-[50%] border break-words text-wrap flex justify-center items-center">
                            Tasks Details
                          </div>
                          <div className="w-full h-[50%] border break-words text-wrap flex ">
                            <div
                              onClick={() => setShowListState("tasktable")}
                              className={`w-[50%] ${
                                showListState === "tasktable"
                                  ? "bg-blue-500 text-white"
                                  : "text-black"
                              } p-1 cursor-pointer flex justify-center items-center`}
                            >
                              {clickedProject?.TypeService?.toLowerCase().includes(
                                "hardware"
                              )
                                ? "Part List"
                                : "Effort Expenses"}
                              {/* {clickedProject?.TypeService === "Hardware" ? "Part List" : "Effort Expenses"} */}
                            </div>
                            <div
                              onClick={() => setShowListState("otherexpenses")}
                              className={` w-[50%] ${
                                showListState === "otherexpenses"
                                  ? "bg-blue-500 text-white"
                                  : "text-black"
                              } p-1 cursor-pointer flex justify-center items-center`}
                            >
                              Other Expenses
                            </div>
                          </div>
                        </div>

                        <div className="w-[22%] flex  bg-[#E8E8E8] justify-center items-center">
                          Progress Tracker
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="w-[30%] font-semibold bg-[#E8E8E8]">
                      <div className="w-full flex h-full">
                        <div className="w-[50%] border p-2 break-words text-wrap flex justify-around items-center align-middle">
                          Task Details
                        </div>
                        <div className="w-[50%] border p-2 break-words text-wrap flex justify-around items-center align-middle">
                          Progress Tracker
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className=" ">
              <>
                {paginatedProjects?.map((row, index) => {
                  const matchedProjectWorkEntries =
                    projectTrackingWorkEntries?.filter(
                      (entry) => entry?.projectid === row?._id
                    ) || [];

                  const matchedOpWorkEntries =
                    matchedProjectWorkEntries?.filter(
                      (entry) => entry?.taskownerid === loggedUser?._id
                    ) || [];

                  const hardwareProjectTrackingParts =
                    hardwareProjectTracking?.filter(
                      (entry) =>
                        entry?.projectid === row?._id &&
                        entry?.taskownerid === loggedUser?._id
                    ) || [];

                  const hardwareDescriptions =
                    descriptionProjectTracking?.filter(
                      (entry) =>
                        entry?.projectid === row?._id &&
                        entry?.taskownerid === loggedUser?._id
                    ) || [];

                  const isUserAssigned = row.Assignedperson?.find(
                    (person) => person.email === LoggedUser // replace with your actual logged user email variable
                  );

                  return (
                    <div
                      ref={(el) => (refs.current[row.ProjectName] = el)}
                      className={`w-full ${
                        isUserAssigned.isRead === false ? " font-bold" : ""
                      } flex cursor-pointer  text-xs`}
                      key={index}
                    >
                      <div className={`${rowID ? "" : "w-[70%]"} flex  `}>
                        <div
                          onClick={() => {
                            const isOpening =
                              openIndex !== index || rowID !== row?._id;
                            setOpenIndex(openIndex === index ? null : index);
                            setRowID(rowID === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className="w-14 border-b text-center pl-3 flex justify-start align-middle items-center"
                        >
                          {startIdx + index + 1}{" "}
                        </div>
                        <div
                          onClick={() => {
                            const isOpening =
                              openIndex !== index || rowID !== row?._id;
                            setOpenIndex(openIndex === index ? null : index);
                            setRowID(rowID === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`${
                            rowID ? "w-32" : "w-[20%]"
                          } border-b flex justify-start align-middle items-center  p-2 break-words text-wrap`}
                        >
                          {getDisplayGroupName(row)}
                        </div>
                        <div
                          onClick={() => {
                            const isOpening =
                              openIndex !== index || rowID !== row?._id;

                            setOpenIndex(openIndex === index ? null : index);
                            setRowID(rowID === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`${
                            rowID ? "w-32" : "w-[20%]"
                          } border-b flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}
                        >
                          {row.ProjectName}
                        </div>
                        <div
                          onClick={() => {
                            const isOpening =
                              openIndex !== index || rowID !== row?._id;

                            setOpenIndex(openIndex === index ? null : index);
                            setRowID(rowID === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`${
                            rowID ? "w-32" : "w-[20%]"
                          } border-b flex-shrink-0 p-1 truncate flex justify-center align-middle items-center text-xs line-clamp-2`}
                        >
                          {row.DateRequested &&
                          !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(row.DateRequested)
                            : " "}
                        </div>
                        <div
                          onClick={() => {
                            const isOpening =
                              openIndex !== index || rowID !== row?._id;

                            setOpenIndex(openIndex === index ? null : index);
                            setRowID(rowID === row?._id ? null : row?._id);
                            setClickedProject(
                              clickedProject === row ? null : row
                            );
                            if (isOpening) {
                              handleleadread(row);
                            }
                          }}
                          className={`${
                            rowID ? "w-32" : "w-[20%]"
                          } border-b p-1 truncate flex justify-center align-middle items-center text-xs line-clamp-2`}
                        >
                          {row.ProjectDueDate &&
                          !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(row.ProjectDueDate)
                            : " "}
                        </div>
                        <div
                          className={`${
                            rowID ? "w-32" : "w-[20%]"
                          } border-b  p-1 truncate flex justify-center align-middle items-center text-xs line-clamp-2`}
                        >
                          <FileUploadOP
                            project={row}
                            leads={leads}
                            employees={employees}
                            isViewOnly={isViewOnly}
                          />
                        </div>
                      </div>

                      <div
                        className={` ${
                          rowID ? "w-[50rem]" : "w-[30%]"
                        } text-center break-words text-wrap border-b`}
                      >
                        {openIndex === index ? (
                          <>
                            <div className="flex w-[50rem] ">
                              <div className="w-[78%] pt-2">
                                {row?.TypeService?.toLowerCase().includes(
                                  "hardware"
                                ) ? (
                                  <OPHardwareOngoing
                                    refresh={refresh}
                                    showListState={showListState}
                                    row={row}
                                    index={index}
                                    hardwareProjectTrackingParts={
                                      hardwareProjectTrackingParts
                                    }
                                    hardwareDescriptions={hardwareDescriptions}
                                    setIsLoading={setIsLoading}
                                    isViewOnly={isViewOnly}
                                  />
                                ) : (
                                  <TaskTrackOP
                                    showListState={showListState}
                                    row={row}
                                    index={index}
                                    loggedUser={loggedUser}
                                    matchedOpWorkEntries={matchedOpWorkEntries}
                                    fetchWorkEntriesProjectTracking={
                                      fetchWorkEntriesProjectTracking
                                    }
                                    setAggregateProgressMap={
                                      setAggregateProgressMap
                                    }
                                    aggregateProgressMap={aggregateProgressMap}
                                    matchedProjectWorkEntries={
                                      matchedProjectWorkEntries
                                    }
                                    setIsLoading={setIsLoading}
                                    matchedDescriptions={hardwareDescriptions}
                                    isViewOnly={isViewOnly}
                                  />
                                )}
                              </div>
                              <div className="w-[22%] p-3 flex justify-center items-center break-words text-wrap">
                                <div className="w-[70%]">
                                  <ProgressTracker
                                    value={
                                      customProjectData.find(
                                        (p) => p.projectid === row._id
                                      )?.calculatedAggregateMap || 0
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className={`${rowID ? "w-[50rem]" : ""}  flex`}>
                            <div
                              onClick={() => {
                                const isOpening =
                                  openIndex !== index || rowID !== row?._id;
                                setOpenIndex(
                                  openIndex === index ? null : index
                                );
                                setRowID(rowID === row?._id ? null : row?._id);
                                setClickedProject(
                                  clickedProject === row ? null : row
                                );
                                if (isOpening) {
                                  handleleadread(row);
                                }
                              }}
                              className={`${
                                rowID ? "w-[78%]" : "w-[50%]"
                              } flex justify-center items-center `}
                              style={{ height: "100px" }}
                            >
                              <span>
                                {" "}
                                {rowID ? "Task Details" : "Multiple"}
                              </span>
                            </div>
                            <div
                              onClick={() => {
                                const isOpening =
                                  openIndex !== index || rowID !== row?._id;

                                setOpenIndex(
                                  openIndex === index ? null : index
                                );
                                setRowID(rowID === row?._id ? null : row?._id);
                                setClickedProject(
                                  clickedProject === row ? null : row
                                );
                                if (isOpening) {
                                  handleleadread(row);
                                }
                              }}
                              className={`${
                                rowID ? "w-[22%]" : "w-[50%]"
                              } pt-3 flex justify-center items-center break-words text-wrap `}
                            >
                              <div className="w-[70%]">
                                <ProgressTracker
                                  value={
                                    customProjectData.find(
                                      (p) => p.projectid === row._id
                                    )?.calculatedAggregateMap || 0
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>

              {paginatedProjects?.length === 0 && (
                <div className="noDataAvailable p-2 text-red-500">
                  No Data Available
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${
            paginatedProjects?.length > 0 ? "p-1" : ""
          } `}
        >
          <div>
            {totalItems > 0 ? (
              <>
                Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                {totalItems} Entries
              </>
            ) : (
              <>
                {paginatedProjects?.length > 0 && (
                  <>Showing {paginatedProjects?.length} Entries</>
                )}
              </>
            )}
          </div>

          {totalPages > 1 && (
            <div className="flex">
              <button
                onClick={() => setCurrentPage(1)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === 1}
                title="First Page"
              >
                <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-2 py-2 mx-2 border rounded"
                disabled={currentPage === 1}
              >
                <ChevronRightIcon className="w-5 h-5 rotate-180" />
              </button>

              {Array.from({ length: 3 }, (_, index) => {
                const pageNumber = currentPage - 1 + index;
                if (pageNumber >= 1 && pageNumber <= totalPages) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => setCurrentPage(pageNumber)}
                      className={`px-4 py-2 mx-2 border rounded ${
                        currentPage === pageNumber ? "bg-gray-300" : ""
                      }`}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                className="px-2 py-2 mx-2 border rounded"
                disabled={currentPage === totalPages}
              >
                <ChevronRightIcon className="w-5 h-5" />
              </button>

              <button
                onClick={() => setCurrentPage(totalPages)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === totalPages}
                title="Last Page"
              >
                <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </>
    </div>
  );
};

export default ProjectOngoingOPDash;
